/* eslint-disable */
export default function AgentAssign({ apiDetail, waEmployee, setNodes, id, wa_authKey, setRefecther }) {
    console.log(apiDetail)
    const agent_assign = (val) => {
        setNodes((nds) =>
            nds.map((node) => {
                if (node.id === id) {
                    node.data.value.api = { agentDetails: val, auth_key: wa_authKey };
                }
                return node;
            })
        );
        setRefecther((prev) => !prev);
    };

    const renderOptions = () => {
        const { data } = waEmployee.data;
        return Object.entries(data).flatMap(([group, employees]) =>
            employees.map(({ empid, emp_name }) => (
                <option key={empid} value={empid}>{emp_name} ({group})</option>
            ))
        );
    };

    const assignedAgent = () => {
        const agentGroup = Object.entries(waEmployee.data.data).find(([_, employees]) => 
            employees.some(({ empid }) => empid == apiDetail.agentDetails)
        );

        if (agentGroup) {
            const [group, employees] = agentGroup;
            const agent = employees.find(({ empid }) => empid == apiDetail.agentDetails);
            return agent ? (
                <div>
                    <p>Assigned Agent - {agent.emp_name} ({group})</p>
                </div>
            ) : null;
        }
        return null;
    };

    return (
        <div className="m-2">
            {apiDetail?.agentDetails ? assignedAgent() : null}
            <select className="form-control" onChange={(e) => agent_assign(e.target.value)} defaultValue={apiDetail?.agentDetails || ""}>
                <option value="" disabled>Select Agent</option>
                {renderOptions()}
            </select>
        </div>
    );
};
